var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"Potential","title":"Potential","logo":_vm.logoSrc}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'fa fa-tv text-primary',
          path: '/dashboard'
        }}}),(_vm.isOwner)?_c('sidebar-item',{attrs:{"link":{
          name: 'Organizations',
          icon: 'fa fa-city text-primary',
          path: '/organizations'
        }}}):_vm._e(),(_vm.hasRoles(['userRead']) && _vm.curOrg.id != null)?_c('sidebar-item',{attrs:{"link":{
          name: 'Users',
          icon: 'fa fa-users text-primary',
          path: '/users'
        }}}):_vm._e(),(_vm.curOrg.id != null && _vm.curOrg.type === 'employer')?_c('sidebar-item',{attrs:{"link":{
          name: 'Job Board',
          icon: 'fa fa-briefcase text-primary',
          path: '/jobboard'
        }}}):_vm._e(),(_vm.curOrg.id != null && (_vm.curOrg.type === 'agency' || _vm.curOrg.type === 'partner'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Resources',
          icon: 'fa fa-briefcase text-primary',
          path: '/resources'
        }}}):_vm._e(),(_vm.curOrg.id != null)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.curOrg.type === 'employer' ? 'Talent' : 'People',
          icon: 'fa fa-id-card text-primary',
          path: '/potentialees'
        }}}):_vm._e(),(_vm.curOrg.id != null)?_c('sidebar-item',{attrs:{"link":{
          name: 'Lists',
          icon: 'fa fa-list text-primary',
          path: '/potentialeelists'
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Help',
          icon: 'fa fa-question-circle text-primary',
          path: '/help'
        }}})],1)],2),_c('div',{staticClass:"main-content",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{on:{"click":_vm.toggleSidebar}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }